export const BUY_ONLINE_EXIT = 'buy_online_exit';
